module.exports = __webpack_public_path__ + "static/media/tpn-signup-userflow.8622d266.png";